import { useState, useEffect } from "react";
import { Grid, MenuItem, Select, FormControl} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { escapeRegExp } from "../../utils";
import LeaveService from "../../services/LeaveService";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import DirectionService from "../../services/DirectionService";
import { Button } from "@material-ui/core";
import FileService from "../../services/FileService";
import * as FileSaver from "file-saver";
import { userDetailContext } from "../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../utils/privilege";
import MainContainer from "../../components/MainContainer";
import { headerData } from "../../data/modules/dashboard-header";
import { headerEtat } from "../../data/modules/etat_header";

function LeavePerSemester(props) {

    const contextData = useContext(userDetailContext);
    var myCurrentDate = new Date();
    var date = myCurrentDate.getFullYear() + '_' + (myCurrentDate.getMonth() + 1) + '_' + myCurrentDate.getDate() + '_' + myCurrentDate.getHours() + '_' + myCurrentDate.getMinutes() + '_' + myCurrentDate.getSeconds();

    var currentYear = myCurrentDate.getFullYear();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const [dir, setDir] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [rows, setRows] = useState([]);
    const [valueSemester, setvalueSemester] = useState(1);
    const [direction_id, setIddir] = useState(1);
    const [column, setColumn] = useState([]);
    //Samuela: paramètrage pour le loader
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);

    function loadTableSemester(semester, currentDirectionId) {

        setOpenLoadingSimpleBackdrop(true);
        LeaveService.getLeaveSemesterForAllUser(semester, currentDirectionId).then((result) => {
            if (result && result.status) {
                setRows(result.data.map((row, index) => ({ ...row, id: index })));
                setOpenLoadingSimpleBackdrop(false);
            } else {
                setRows([]);
                setOpenLoadingSimpleBackdrop(false);
            }
        })
    }

    
    useEffect(() => {
        // loadTable(month, direction_id);
        //get all direction
        DirectionService.getDirection().then((res) => {
            if (res && res.status) {
                setDir(res.data);
            }
        })
    }, []);

    useEffect(() => {
        if(valueSemester == 1){
            setColumn(columnFirstSemester);
        }else{
            setColumn(columnSecondSemester);
        }
        loadTableSemester(valueSemester,direction_id);
    }, [valueSemester]);

    const requestSearch = (searchValue) => {
        setSearchText(searchValue);
        const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
        const filteredRows = [...rows].filter((row) => {
            return Object.keys(row).some((field) => {
                return searchRegex.test(row[field].toString());
            });
        });
    };

    function handleClickExport() {
        LeaveService.doExportLeaveSemester("semester_leave",valueSemester, rows, direction_id).then((res) => {
            if (res && res.status) {
                const filenameResult = res.data;
                console.log("file***", filenameResult);
                FileService.readExcelFileContent("Leaves", filenameResult).then((result) => {
                    if (result && result.status) {
                        const data = new Blob([result.data], { type: fileType });
                        FileSaver.saveAs(data, filenameResult);
                    }
                })
            }
        })
    }

    function handleChange(ev) {
        const semesterSelected = ev.target.value;
        setvalueSemester(semesterSelected);
        //loadTable(month, direction_id);
    }

    function handleChangeDirection(event) {
        const value = event.target.value;
        setIddir(value);
        //loadTable(month, value);
    }

    const columnFirstSemester = [
        {
            field: 'matricule',
            headerName: 'Matricule',
            width: 150,
        },
        {
            field: 'name',
            headerName: 'Nom et Prénoms',
            width: 300,
        },
        {
            field: 'function_name',
            headerName: 'Poste actuel',
            width: 200,
        },
        {
            field: 'service_code',
            headerName: 'Direction',
            width: 150,
        },
        {
            field: 'solde0',
            headerName: `Solde de congé fin Décembre ${currentYear - 1}`,
            width: 350,
        },
        {
            field: 'leaveTaken1',
            headerName: `Congé pris Janvier`,
            width: 250,
        },
        {
            field: 'solde1',
            headerName: `Solde de congé fin Janvier`,
            width: 300,
        },

        {
            field: 'leaveTaken2',
            headerName: `Congé pris Février`,
            width: 250,
        },
        {
            field: 'solde2',
            headerName: `Solde de congé fin Février`,
            width: 300,
        },

        {
            field: 'leaveTaken3',
            headerName: `Congé pris Mars`,
            width: 250,
        },
        {
            field: 'solde3',
            headerName: `Solde de congé fin Mars`,
            width: 300,
        },

        {
            field: 'leaveTaken4',
            headerName: `Congé pris Avril`,
            width: 250,
        },
        {
            field: 'solde4',
            headerName: `Solde de congé fin Avril`,
            width: 300,
        },

        {
            field: 'leaveTaken5',
            headerName: `Congé pris Mai`,
            width: 250,
        },
        {
            field: 'solde5',
            headerName: `Solde de congé fin Mai`,
            width: 300,
        },

        {
            field: 'leaveTaken6',
            headerName: `Congé pris Juin`,
            width: 250,
        },
        {
            field: 'solde6',
            headerName: `Solde de congé fin Juin`,
            width: 300,
        },
    ];

    const columnSecondSemester = [
        {
            field: 'matricule',
            headerName: 'Matricule',
            width: 150,
        },
        {
            field: 'name',
            headerName: 'Nom et Prénoms',
            width: 300,
        },
        {
            field: 'function_name',
            headerName: 'Poste actuel',
            width: 200,
        },
        {
            field: 'service_code',
            headerName: 'Direction',
            width: 150,
        },
        {
            field: 'solde0',
            headerName: `Solde de congé fin Juin`,
            width: 300,
        },

        {
            field: 'leaveTaken1',
            headerName: `Congé pris Juillet`,
            width: 250,
        },
        {
            field: 'solde1',
            headerName: `Solde de congé fin Juillet `,
            width: 300,
        },

        {
            field: 'leaveTaken2',
            headerName: `Congé pris Août`,
            width: 250,
        },
        {
            field: 'solde2',
            headerName: `Solde de congé fin Août`,
            width: 300,
        },

        {
            field: 'leaveTaken3',
            headerName: `Congé pris Septembre`,
            width: 250,
        },
        {
            field: 'solde3',
            headerName: `Solde de congé fin Septembre`,
            width: 300,
        },

        {
            field: 'leaveTaken4',
            headerName: `Congé pris Octobre`,
            width: 250,
        },
        {
            field: 'solde4',
            headerName: `Solde de congé fin Octobre`,
            width: 300,
        },

        {
            field: 'leaveTaken5',
            headerName: `Congé pris Novembre`,
            width: 250,
        },
        {
            field: 'solde5',
            headerName: `Solde de congé fin Novembre`,
            width: 300,
        },

        {
            field: 'leaveTaken6',
            headerName: `Congé pris Décembre`,
            width: 250,
        },
        {
            field: 'solde6',
            headerName: `Solde de congé fin Décembre`,
            width: 300,
        },
    ];
    return (
        <MainContainer {...headerEtat}>
            <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={valueSemester} name="semester" onChange={handleChange} >
                            <MenuItem value="1">1er semestre</MenuItem>
                            <MenuItem value="2">2ème semestre</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>

                    <FormControl fullWidth variant="outlined" size="small">
                        <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={direction_id} name="direction_id" onChange={handleChangeDirection}>
                            {dir.map((row) => (
                                <MenuItem value={row.direction_id}>{row.code}</MenuItem>

                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>

                    {hasPrivilege(contextData.privileges, 'RH_Button_export_monthly_report') && rows.length > 0 &&
                        <Button variant="contained" onClick={handleClickExport} style={{ fontWeight: 600 }}>EXPORTER</Button>
                    }
                </Grid>
                {/* {valueSemester===1 && <LeaveSecondSemesterTable/>}
                {valueSemester===2 && <LeaveFirstSemesterTable/>} */}
                {/* {valueSemester === 1 &&
                    <Grid item xs={12}>
                        <div style={{ height: "70vh", width: "100%" }}>
                            <DataGrid
                                columns={columnFirstSemester}
                                rows={rows}
                                pageSize={7}
                                rowsPerPageOptions={[7]}
                                disableSelectionOnClick
                                componentsProps={{
                                    toolbar: {
                                        value: searchText,
                                        onChange: (event) => requestSearch(event.target.value),
                                        clearSearch: () => requestSearch(""),
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                }
                {valueSemester === 2 &&
                    <Grid item xs={12}>
                        <div style={{ height: "70vh", width: "100%" }}>
                            <DataGrid
                                columns={columnSecondSemester}
                                rows={rows}
                                pageSize={7}
                                rowsPerPageOptions={[7]}
                                disableSelectionOnClick
                                componentsProps={{
                                    toolbar: {
                                        value: searchText,
                                        onChange: (event) => requestSearch(event.target.value),
                                        clearSearch: () => requestSearch(""),
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                } */}

                <Grid item xs={12}>
                    <div style={{ height: "70vh", width: "100%" }}>
                        <DataGrid
                            columns={column}
                            rows={rows}
                            pageSize={7}
                            rowsPerPageOptions={[7]}
                            disableSelectionOnClick
                            componentsProps={{
                                toolbar: {
                                    value: searchText,
                                    onChange: (event) => requestSearch(event.target.value),
                                    clearSearch: () => requestSearch(""),
                                },
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </MainContainer>
        // <ListLeaveCardPortal/>

    );
}
export default LeavePerSemester;